import React from "react";

import styled from "styled-components";

import Text from "components/atoms/text/Text";

const Container = styled.div`
    padding: 8px;
    width: 240px;
    background-color: var(--color-White);
    border: solid 1px var(--color-Outline);
    border-radius: 4px;
`;

const OptionList = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    max-height: 200px;
`;

const OptionItem = styled.div`
    border-radius: 4px;
    overflow: hidden;
`;

const OptionLabel = styled.label`
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 28px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 80ms ease-in;

    input {
        display: block;
    }

    &:hover {
        background-color: var(--color-ButtonHover4);
    }
`;

function TableColumnVisibilityMenu(props) {
    const { columns, tableConfig, setTableConfig, hiddenColumnIds = [] } = props;

    return (
        <Container>
            <Text margin="0 0 16px 0" variant="body-md-500" textAlign="left">
                테이블 항목
            </Text>
            <OptionList onClick={(e) => e.stopPropagation()}>
                {columns.map((column) => {
                    if (hiddenColumnIds.includes(column.id)) {
                        return null;
                    }

                    const tableColumn = tableConfig.find((item) => item.id === column.id);
                    const checked = tableColumn ? tableColumn.visibility : true;

                    return (
                        <OptionItem key={column.id}>
                            <OptionLabel>
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={(e) => {
                                        setTableConfig((prev) =>
                                            prev.map((item) =>
                                                item.id === column.id
                                                    ? {
                                                          ...item,
                                                          visibility: e.target.checked,
                                                      }
                                                    : item,
                                            ),
                                        );
                                        e.stopPropagation();
                                    }}
                                />
                                <Text margin="0 0 0 4px" variant="body-sm-400">
                                    {column.name}
                                </Text>
                            </OptionLabel>
                        </OptionItem>
                    );
                })}
            </OptionList>
        </Container>
    );
}

export default TableColumnVisibilityMenu;
